'use client';
import React, { useEffect } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { cn } from '~/lib/utils';

export function AnimatedNumber({
  value,
  className,
  isFloat,
}: {
  value: number;
  className?: string;
  isFloat?: boolean;
}) {
  const spring = useSpring(value, { mass: 0.8, stiffness: 25, damping: 15 });
  const display = useTransform(spring, (current) =>
    isFloat ? current.toFixed(2) : Math.round(current).toLocaleString(),
  );

  const { ref, inView } = useInView({
    triggerOnce: false, // Change it to false if you want to trigger again when it comes back to view
  });

  useEffect(() => {
    if (inView) {
      spring.set(value);
    } else {
      spring.set(0);
    }
  }, [spring, value, inView]);

  return (
    <motion.span ref={ref} className={cn('inline-block', className)}>
      {display}
    </motion.span>
  );
}
